module.exports = "<ciu-desktop-menu></ciu-desktop-menu>\r\n "


//////////////////
// WEBPACK FOOTER
// C:/Users/majli/reposales365/sale365/src/app/header/main-menu/main-menu.component.html
// module id = ../../../../../src/app/header/main-menu/main-menu.component.html
// module chunks = main